
// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('product.volumediscounts', {
        url: '/volumediscounts',
        views: {'productList@product': {
            templateUrl: 'main/product/volumediscounts/volumediscounts.tpl.html',
            controller: 'VolumeDiscountsController as vm'
        }},
        resolve: {
            volumeDiscounts: volumeDiscountsResolver
        }
    });
}

// @ngInject
function volumeDiscountsResolver(VolumeDiscountsApiService) {
    return VolumeDiscountsApiService.getVolumeDiscounts();
}

// @ngInject
function VolumeDiscountsController($rootScope, $state, $scope, volumeDiscounts, VolumeDiscountsApiService,loadSpinnerService) {
    var vm = this;

    vm.currentUser = $rootScope.currentUser;

    vm.volumeDiscounts = volumeDiscounts;
    vm.selectedVolumeDiscountId = 0;
    vm.searchTerm = "";
    vm.currentPage = 1;
    vm.itemsPerPage = null;

    vm.searchTermChange = searchTermChange;

    activate();

    function activate() {
        $scope.$watch(function() { return $state.params.volumeDiscountId; }, function(newValue, oldValue) {
            vm.selectedVolumeDiscountId = parseInt($state.params.volumeDiscountId, 10);
        });

        $rootScope.$on('VolumeDiscount.Changed', function(event, response) {
            loadVolumeDiscounts();
        });
    }

    function loadVolumeDiscounts() {
        loadSpinnerService.start('mainSpinner');
        VolumeDiscountsApiService.getVolumeDiscounts(vm.currentPage,vm.searchTerm,vm.itemsPerPage).then(function(response) {
            vm.volumeDiscounts = response;
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner',{force: true});
        });
    }

    function searchTermChange() {
        vm.currentPage = 1;
        loadVolumeDiscounts();
    }

}

angular
    .module('product.volumediscounts', ['volumediscounts.api','volumediscounts.volumediscount'])
    .config(stateConfig)
    .controller('VolumeDiscountsController', VolumeDiscountsController);
